import { LayoutName } from "components/context/LayoutContext";
import AppLayout from "components/layout/AppLayout";
import DocumentHead from "components/shared/DocumentHead";
import React, { useEffect } from "react";
import { Outlet, UIMatch, useLocation, useMatches } from "react-router-dom";
import { RouteHandle } from "types/router";

const Root: React.FC = () => {
  const matches = useMatches() as UIMatch<unknown, RouteHandle>[];
  const location = useLocation();
  const params = new URLSearchParams(window.location.search);
  const hideNavigation = JSON.parse(params.get("hideNavigation"));

  const { pathname } = location;
  const match = matches[matches.length - 1];
  const { title } = match?.handle || {};

  const currentMatch = matches[matches.length - 1];
  const routeParent = currentMatch.handle?.parent;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <AppLayout
      layoutName={LayoutName.withSidebar}
      routeParent={routeParent}
      hideNavigation={hideNavigation}
    >
      <DocumentHead title={title} />

      <Outlet />
    </AppLayout>
  );
};

export default Root;
